var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-loading',{attrs:{"can-cancel":true,"is-full-page":true},model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}}),_c('div',{staticClass:"ml-0 mr-0 mt-0"},[_c('apex-chart',{ref:"apexChart",attrs:{"height":"130","type":"rangeBar","options":_vm.chartOptions,"series":_vm.cSeries}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }